import React, { useEffect } from 'react';
import { LoadingSpinnerProps } from './interfaces/ILoadingSpinner';

/**
 * LoadingSpinner
 * Renders a loading spinner with optional text.
 * @component
 * @param {LoadingSpinnerProps} props - Props for LoadingSpinner.
 * @returns {JSX.Element} Spinner component.
 */
export function LoadingSpinner({ text = 'Loading...' }: LoadingSpinnerProps) {
    useEffect(() => {
        if (typeof window !== 'undefined' && document && !document.head.querySelector('style[data-spinner]')) {
            const spinnerStyle = document.createElement('style');
            spinnerStyle.innerHTML = `@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
            spinnerStyle.setAttribute('data-spinner', 'true');
            document.head.appendChild(spinnerStyle);
        }
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '2rem 0',
            }}
        >
            <div
                className='spinner'
                style={{
                    width: 80,
                    height: 80,
                    border: '4px solid #eee',
                    borderTop: '4px solid #4caf50',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                }}
            ></div>
            <div style={{ marginTop: 12, color: '#666' }}>{text}</div>
        </div>
    );
}
